import { useMemo } from "react";

import { useAllPrograms } from "~/modules/project/api/program/programQueries.ts";
import type { FormInputOption } from "~/types/form.ts";
import { mapDataToInputOptionsData } from "~/utils/form/formUtils.ts";
import { byObjectProperty } from "~/utils/sortFunctions.ts";


const useClientsProgramSelectOptions = (clientId: string): FormInputOption[] => {
	const { data: allProgramsData } = useAllPrograms();
	return useMemo(() => {
		if (allProgramsData && clientId) {
			const filteredProgramsData = allProgramsData.filter((clientContactPerson) => {
				return clientContactPerson.clientId === clientId;
			}).sort(byObjectProperty("title"));
			return mapDataToInputOptionsData(filteredProgramsData, "id", "title");
		}
		return [];
	}, [allProgramsData, clientId]);
};

export default useClientsProgramSelectOptions;

